"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _react = _interopRequireWildcard(require("react"));
var _Contactform = _interopRequireDefault(require("./Contactform"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Renders the social media icons.
var SocialMedia = function SocialMedia(_ref) {
  var id = _ref.id,
    data = _ref.data,
    lang = _ref.lang,
    openMail = _ref.openMail,
    _setSendMail = _ref.setSendMail,
    CaptchaKey = _ref.CaptchaKey;
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    socialMenu = _React$useState2[0],
    setSocialMenu = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    form = _React$useState4[0],
    setForm = _React$useState4[1];
  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };
  var _React$useState5 = _react["default"].useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    emailInfo = _React$useState6[0],
    setEmailInfo = _React$useState6[1];
  var _React$useState7 = _react["default"].useState(data),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    socialMedia = _React$useState8[0],
    setSocialMedia = _React$useState8[1];
  (0, _react.useEffect)(function () {
    for (var i = 0; i < socialMedia.length; i++) {
      var item = socialMedia[i];
      if (item.icon === 'Mail') {
        if (openMail && openMail === true) {
          setForm(true);
        }
        setEmailInfo(item);
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "contactSocialMedia menu_".concat(!socialMenu ? 0 : 1)
  }, form && /*#__PURE__*/_react["default"].createElement("div", {
    className: "contact_form_wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Contactform["default"], {
    CaptchaKey: CaptchaKey,
    mailInfo: emailInfo,
    id: "".concat(id),
    lang: lang,
    close: function close() {
      return setForm(false);
    },
    setSendMail: function setSendMail(e) {
      return _setSendMail(e);
    }
  })), socialMedia.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "socialMedia_0",
    style: {
      opacity: socialMenu === 0 ? '1' : '0'
    }
  }, socialMedia.slice(0, 9).map(function (_ref2, index) {
    var icon = _ref2.icon,
      url = _ref2.url,
      name = _ref2.name,
      title = _ref2.title;
    return icon === 'Mail' ? /*#__PURE__*/_react["default"].createElement("a", {
      className: "".concat(icon, " socialMedia_item"),
      key: index,
      target: "_blank",
      rel: "noopener",
      onClick: function onClick() {
        return icon === 'Mail' && setForm(true);
      }
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: icon
    }), icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: "socialMedia_title"
    }, translate('contact_us'))) : /*#__PURE__*/_react["default"].createElement("a", {
      className: "".concat(icon, " socialMedia_item"),
      href: url[6] === '/' ? url : "https://".concat(url),
      key: index,
      target: "_blank",
      rel: "noopener",
      onClick: function onClick() {
        return icon === 'Mail' && setForm(true);
      }
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: icon
    }), icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: "socialMedia_title"
    }, name, " ", title));
  })), socialMedia.length > 10 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    animated: true,
    className: "More",
    name: "ArrowRight",
    onClick: function onClick() {
      return setSocialMenu(!socialMenu ? 1 : 0);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "socialMedia_1",
    style: {
      opacity: socialMenu === 1 ? '1' : '0'
    }
  }, socialMedia.slice(9, 18).map(function (_ref3, index) {
    var icon = _ref3.icon,
      url = _ref3.url,
      name = _ref3.name,
      title = _ref3.title;
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "".concat(icon, " socialMedia_item"),
      href: url,
      key: index,
      target: "_blank",
      rel: "noopener"
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      animated: true,
      name: icon
    }), icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: "socialMedia_title"
    }, name, " ", title));
  }))));
};
var _default = exports["default"] = SocialMedia;